<script>
import { computed, defineAsyncComponent, onMounted, ref } from "vue";
import MdcMenu from "@/components/MdcMenu/MdcMenu";
import MdcSelect from "@/components/MdcSelect/MdcSelect";
import MdcForm from "@/components/MdcForm/MdcForm.vue";
import { MDCTextField } from "@material/textfield";

import { favCount } from "@/utils";

export default {
    components: {
        "factsheet-app": defineAsyncComponent(() =>
            import("@/components/FactsheetApp/FactsheetApp")
        ),
        "mdc-accordion": defineAsyncComponent(() =>
            import("@/components/MdcAccordion/MdcAccordion")
        ),
        "mdc-accordion-item": defineAsyncComponent(() =>
            import("@/components/MdcAccordion/MdcAccordionItem")
        ),
        'to-top': defineAsyncComponent(() => import("@/components/ToTop")),
        "mdc-menu": MdcMenu,
        MdcSelect,
        MdcForm
    },
    setup() {
        const mobileNavOpen = ref(false);

        const toggleMobileNav = () => {
            mobileNavOpen.value = !mobileNavOpen.value;
            mobileNavOpen.value
                ? document.body.classList.add("page-header__navigation--active")
                : document.body.classList.remove(
                      "page-header__navigation--active"
                  );
        };

        const toggleMobileNavClass = computed(() => {
            return {
                "is-active": mobileNavOpen.value,
            };
        });

        onMounted(() => {
            let textFields = document.querySelectorAll(".mdc-text-field");
            for (let x = 0; x < textFields.length; x++) {
                new MDCTextField(textFields[x]);
            }
        });

        return {
            favCount,
            toggleMobileNav,
            toggleMobileNavClass,
        };
    },
};
</script>

<style lang="scss">
@use "@/scss/main";
</style>
